import * as Highcharts from 'highcharts'
import 'highcharts/modules/accessibility'
import 'highcharts/highcharts-more'
import 'highcharts/modules/exporting'
import 'highcharts/modules/export-data'

Highcharts.setOptions({
    lang: {
        downloadPNG: 'Baixar PNG',
        downloadJPEG: 'Baixar JPEG',
        downloadPDF: 'Baixar PDF',
        downloadSVG: 'Baixar SVG',
        contextButtonTitle: 'Menu de exportação',
        viewFullscreen: 'Tela cheia',
        printChart: 'Imprimir gráfico',
        downloadCSV: 'Baixar CSV',
        downloadXLS: 'Baixar XLS',
        exitFullscreen: 'Sair da tela cheia',
        loading: 'Carregando...',
        noData: 'Sem dados para exibir',
        resetZoom: 'Redefinir zoom',
        resetZoomTitle: 'Redefinir nível de zoom 1:1',
    }
})

export default Highcharts